const API_URL = "https://api.faculdadecerrado.edu.br/";
// const API_URL = "http://localhost:8000/";

const ConfigService = {
  API_URL,
};

export default ConfigService;
